import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import SectionSeparatorLine from 'Components/SectionSeparatorLine'
import AppLink from 'Components/AppLink'
import { useGoogleAnalytics, useContent } from './hooks'

// import css from './style.css'
import {
  _CollapseContainer, _CollapseInput, _ToggleLabel, _SeoText, _Icon, _BarCont, _Horizontal,
  _Vertical, _Title, _Content, _ContentInner, _SeperatorLine, _SearchPageLink, _VisibleContent,
} from './styles'

const Collapsible = ({
  inputId,
  lookups,
  gaActionTitle,
  title,
  seoText,
  children,
  customClasses = {},
  showSeparatorLine = true,
  className = '',
  googleAnalyticsEvent,
  CustomIcon,
  isCollapsible = true,
  visibleContent,
  mobileBrowser,
  defaultShowState,
  getCollapsibleState,
  openCollapseTargetId,
  searchPageUrl,
  schoolGAEvent = () => {},
  onClick = () => {},
  schoolSearchPageUrl,
}) => {
  const id = inputId || 'collapseInput'
  const { showContent, setContent } = useContent({
    mobileBrowser,
    defaultShowState,
    getCollapsibleState,
    id,
    openCollapseTargetId,
  })

  const handleCheckboxClick = useGoogleAnalytics({
    lookups,
    gaActionTitle,
    title,
    showContent,
    googleAnalyticsEvent,
  })
  return (
    <_CollapseContainer containerCustomClass={customClasses.collapseContainer} className={className} >
      {showSeparatorLine && (
        <_SeperatorLine>
          <SectionSeparatorLine globalClassName={'collapsible-seperator-line'} />
        </_SeperatorLine>
      )}
      <_CollapseInput
        id={id}
        type="checkbox"
        onChange={handleCheckboxClick}
        inputCustomClass={customClasses.collapseInput}
        onClick={setContent}
        checked={!showContent}
      />
      <_ToggleLabel htmlFor={id} isCollapsible={isCollapsible}>
        <_Title labelCustomClass={customClasses.collapseLabel}>
          {title}
          {seoText && <_SeoText>{seoText}</_SeoText>}
          {
            searchPageUrl ?
              <_SearchPageLink>
                <AppLink
                  openNewTab
                  alt={'View on map'}
                  to={searchPageUrl}
                  // onClick={() => {
                  //   googleAnalyticsEvent({
                  //     category: pageFrom,
                  //     action: `[Click][Price history from ${pageFrom}][View all history]`,
                  //   })
                  // }}
                >
                  View on map
                </AppLink>
              </_SearchPageLink>
              : schoolSearchPageUrl ? (
                <_SearchPageLink>
                  <Link
                    to={schoolSearchPageUrl}
                    onClick={() => {
                      schoolGAEvent()
                      onClick()
                    }}
                  >
                    View on map
                  </Link>
                </_SearchPageLink>
              ) : ''
          }
        </_Title>
        {CustomIcon ? (
          <CustomIcon />
        ) : (
          isCollapsible && (
            <_Icon>
              <_BarCont>
                <_Horizontal />
                <_Vertical />
              </_BarCont>
            </_Icon>
          )
        )}

      </_ToggleLabel>

      {
        visibleContent &&
          <_VisibleContent
            visibleContentCustomClass={customClasses.visibleContent}
          >
            {visibleContent}
          </_VisibleContent>
      }

      <_Content contentCustomClass={customClasses.collapseContent}>
        <_ContentInner contentInnerCustomClass={customClasses.contentInner}>{children}</_ContentInner>
      </_Content>
    </_CollapseContainer>
  )
}

Collapsible.propTypes = {
  inputId: PropTypes.string,
  googleAnalyticsEvent: PropTypes.func,
  getCollapsibleState: PropTypes.func,
  title: PropTypes.string,
  gaActionTitle: PropTypes.string,
  seoText: PropTypes.string,
  showSeparatorLine: PropTypes.bool,
  lookups: PropTypes.shape({
    component: PropTypes.string,
  }),
  // style object
  customClasses: PropTypes.shape({
    collapseContainer: PropTypes.arrayOf(PropTypes.string),
    collapseLabel: PropTypes.arrayOf(PropTypes.string),
    visibleContent: PropTypes.arrayOf(PropTypes.string),
    content: PropTypes.arrayOf(PropTypes.string),
    collapseIcon: PropTypes.arrayOf(PropTypes.string),
    collapseContent: PropTypes.arrayOf(PropTypes.string),
    contentInner: PropTypes.arrayOf(PropTypes.string),
  }),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.node,
  ]),
  className: PropTypes.string,
  CustomIcon: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
  ]),
  isCollapsible: PropTypes.bool,
  visibleContent: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.node,
  ]),
  mobileBrowser: PropTypes.bool,
  defaultShowState: PropTypes.bool,
  openCollapseTargetId: PropTypes.string,
  searchPageUrl: PropTypes.string,
  schoolGAEvent: PropTypes.func,
  schoolSearchPageUrl: PropTypes.string,
  onClick: PropTypes.func,
}
export default memo(Collapsible)
